import { render, staticRenderFns } from "./teachers.vue?vue&type=template&id=fdace1f4&scoped=true"
import script from "./teachers.vue?vue&type=script&lang=js"
export * from "./teachers.vue?vue&type=script&lang=js"
import style0 from "./teachers.vue?vue&type=style&index=0&id=fdace1f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdace1f4",
  null
  
)

export default component.exports